/* file description */

import { useCallback, useRef, useState } from 'react';
import { Modal } from 'antd';
import { COLUMN_FROM } from '../../../effects/consts';
import { getModuleRecordList, getAutoCode, batchCreate } from '@/common/asset-apis/assetModel';
import { OnLinkShowModalTableSelect, OnRecordSelectLinkShowModalEnter, SetShowFieldsValue, UseLinShowModalSelect } from './type';
import { cloneDeep } from 'lodash';
import { postRecordList } from '@/api/npi.api';
import getShowTreeDataFromApiName from '../component/FilterTree/service';

export const useLinShowModalSelect: UseLinShowModalSelect = ({ setShowLabel, API, isMulti, setOptionList, emitEvent, moduleInfo }) => {
  // 弹窗展示控制
  const [showLinkShowModal, linkShowModalContrulor] = useState(false);
  // 选中控制
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // selected选择控制
  const SelectedRef = useRef<Record<any, any> | null>(null);
  // 选择后的回调处理
  const onSelectChange = useCallback<OnLinkShowModalTableSelect>(
    (_selectedIDList: React.Key[], selectedRecordList: Array<Record<any, any>>) => {
      setSelectedRowKeys(_selectedIDList)
      if (isMulti) {
        SelectedRef.current = selectedRecordList || null;
      } else {
        SelectedRef.current = selectedRecordList[0] || null;
      }
    },
    [SelectedRef.current],
  );
  
  // 单击行时处理
  const clickRow = (key: any, record: any) => {
    if (isMulti) {
      const keysList = [...selectedRowKeys]
      if (keysList.indexOf(key) >= 0) {
        keysList.splice(keysList.indexOf(key), 1)
      } else {
        keysList.push(key)
      }
      setSelectedRowKeys(keysList)
    } else {
      SelectedRef.current = record
      setSelectedRowKeys([key])
    }
  }
  
  // 联动字段更新
  const setShowFieldsValue:SetShowFieldsValue = (form, field, columnFrom, config, type, chooseItems) => {
    if (isMulti) {
      return {};
    }
    const { options = [] } = field.bizConfig || {};
    const values: Record<any,any> = {};
    // 联动保存字段
    options.forEach((item: { moduleField: any; linkField: any }) => {
      values[item.moduleField] = type === 'reset' ? '' : chooseItems?.[item.linkField];
    });
    return values;
  }

  const setInputLabel = async (field: any, initLabel: string, initValue: string) => {
    const { labelBindLabel, isBindLabel, treeId, labelModule, labelBindKey } = field.options || {};
    const option: Record<any,any> = {}
    // 子表联动显示字段获取
    if (isBindLabel) {
      try {
        const res = await getModuleRecordList(
          API.FetchAPI,
          treeId,
          labelModule,
          {
            moduleID: labelModule,
            namespaceID: treeId,
            limit: 100,
            filter: `${labelBindKey} = '${initValue}'`
          }
        )
        const recordValues = res.set?.[0]?.values || []
        recordValues.forEach((item:any) => {
          if(item.name === labelBindLabel) {
            option[field?.options?.labelBindLabel] = item.value
            option[field?.options?.value] = initValue
            setOptionList([option])
            // setShowLabel(item.value)
          }
        })
      } catch {
        option[field?.options?.labelBindLabel] = initValue
        option[field?.options?.value] = initValue
        setOptionList([option])
        // setShowLabel(initValue)
      }
    } else {
      option[field?.options?.label] = initLabel || initValue
      option[field?.options?.value] = initValue
      setOptionList([option])
      // setShowLabel(initLabel || initValue)
    }
  }

  const getAllType = async () => {
    const listRes = await postRecordList({
      app_id: 'base',
      model_id: 'bd_feature',
    });
    const typeMap: any = {};
    const types = listRes.data?.map((el: any) => el.feature_type).filter((el: string, ind: number, arr: string[]) => arr.indexOf(el) === ind);
    types.forEach((el: string) => {
      const list = listRes.data?.filter((item: any) => item.feature_type === el);
      typeMap[el] = list;
    });
    return typeMap;
  };

  const saveFeatureList = async (cpartCode: string, choosenCode: any) => {
    if (choosenCode) {
      const data = {
        bd_bpart_product_classification_number: choosenCode.bd_bpart_product_classification_number,
        bd_brand_classification_type_code: choosenCode.bd_brand_classification_type_code,
        bd_brand_classification_number: choosenCode.product_brand,
      };
      const resData: any = await getShowTreeDataFromApiName(data, 'getShowTreeFromCpartData');
      const treeList = resData?.treeList || [];
      const allType = await getAllType();
      const list: any[] = [];
      treeList?.map((el: any) => {
        const typeList = el.bd_feature_type_number;
        return {
          ...el,
          bd_feature_type_number: !Array.isArray(typeList) ? typeList?.split(',') : typeList,
        };
      }).forEach((el: any) => {
        el.bd_feature_type_number?.forEach((type: string) => {
          allType[type]?.forEach((item: any) => {
            if (item.product_type === el.product_type && item.feature_type === type) {
              const newItem: any = {
                // 产品编码
                product_code: cpartCode,
                // 结构部件
                bd_material_classification_number: el.bd_material_classification_number,
                // 部件id
                md_bbom_template_line_id: el.md_bbom_template_line_id,
                // 特征参数类型
                bd_feature_type_classification_number: type,
                // 特征参数
                feature_code: item.number,
                // 产品或物料品类
                product_type: item.product_type,
              };
              list.push(newItem);
            }
          });
        });
      });
      if (list?.length > 0) {
        const params = {
          namespaceID: 'master_data',
          moduleID: 'md_cpart_product_feature_info',
          parameterList: list,
        };
        batchCreate(API.FetchAPI, params);
      }
    }
  };

  // 弹窗确认按钮被点击后的处理
  const onModalEnter = useCallback<OnRecordSelectLinkShowModalEnter>(({ onChange, fieldName, form, field, columnFrom, config, chooseItems, nodeType, customCode, onlyCode, setRowData }) => {
    if (nodeType === 'sale') {
      if (!chooseItems) {
        linkShowModalContrulor(false);
        return;
      }
      // 判断是否有cpart
      const params = {
        moduleID: 'md_cpart_product_base_info',
        namespaceID: 'master_data',
        filter: `spu = '${chooseItems.code}' AND cus_org_code = '${customCode}' AND ${field?.bizConfig?.onlyCodeType} = '${onlyCode}'`,
      };
      getModuleRecordList(API.FetchAPI, 'master_data', 'md_cpart_product_base_info', params).then((result: any) => {
        if (result?.set?.length < 1) {
          getAutoCode(API.FetchAPI, { prefix: 'CP' }).then((res: any) => {
            const autoCode = res[1]?.data?.data;
            const caprtInfo: Record<any, any> = {};
            caprtInfo.product_code = autoCode; // 客户产品编码
            caprtInfo.product_name = chooseItems.name; // 客户产品名称
            caprtInfo.spu = chooseItems.code; // 销售产品
            caprtInfo.product_type = chooseItems.product_type; // 产品品类
            caprtInfo.bd_bpart_product_classification_number = chooseItems.bd_bpart_product_classification_number; // 设计分类
            caprtInfo.bd_brand_classification_type_code = chooseItems.bd_brand_classification_type_code; // 品牌类型
            caprtInfo.bd_brand_classification_number = chooseItems.product_brand; // 品牌
            caprtInfo.audit_status = '03';
            caprtInfo.managerial_status = '02';
            caprtInfo.product_desc = chooseItems.desc;
            caprtInfo.sale_basic_price = chooseItems.sale_basic_price;
            caprtInfo.unit_code = chooseItems.unit_code;
            caprtInfo.product_model = chooseItems.product_model;
            caprtInfo.cus_org_code = customCode; // 客户经营组织编码
            caprtInfo[field?.bizConfig?.onlyCodeType] = onlyCode; // 唯一编号
            const cpartParams = {
              namespaceID: 'master_data',
              moduleID: 'md_cpart_product_base_info',
              parameterList: [caprtInfo],
            };
            saveFeatureList(autoCode, chooseItems);
            batchCreate(API.FetchAPI, cpartParams).then(() => {
              setOptionList([{
                name: chooseItems.name,
                code: autoCode,
              }]);
              const bindValues: Record<any, any> = setShowFieldsValue(form, field, columnFrom, config, '', chooseItems);
              if (columnFrom === COLUMN_FROM.TABLE && field?.bizConfig?.spartCode) {
                setRowData(config.rowIndex, {
                  [field.name]: autoCode,
                  [field?.bizConfig?.spartCode]: chooseItems.code,
                  ...bindValues,
                });
                // const dataList = cloneDeep(config?.formValue);
                // const rowData = {
                //   ...config?.rowValue,
                //   [field.name]: autoCode,
                //   [field?.bizConfig?.spartCode]: chooseItems.code,
                //   ...bindValues,
                // };
                // dataList.splice(config.rowIndex, 1, rowData);
                // config.setRowsData(dataList);
                emitEvent && emitEvent({ value: chooseItems.code, moduleName: moduleInfo.handle, fieldName: field?.bizConfig?.spartCode, rowIndex: config.rowIndex, touchConfig: 'change' });
              } else {
                onChange && onChange(autoCode);
              }
              linkShowModalContrulor(false);
            });
          });
        } else {
          linkShowModalContrulor(false);
        }
      });
    }
    if (nodeType !== 'sale') {
      if (!chooseItems) {
        Modal.confirm({
          content: '您未选择任何一项，这将会将其设为空，确认此操作吗?',
          onOk: () => {
            // TODO 联动更新
            // setShowFieldsValue(form, field, columnFrom, config, 'reset')
            onChange && onChange(null);
            linkShowModalContrulor(false);
          },
        });
        return;
      }
      setOptionList([chooseItems]);
      // 选择时给联动字段赋值
      const bindValues: Record<any, any> = setShowFieldsValue(form, field, columnFrom, config, '', chooseItems);
      // onChange && onChange(chooseItems.code);
      if (columnFrom === COLUMN_FROM.TABLE && field?.bizConfig?.spartCode) {
        setRowData(config.rowIndex, {
          [field.name]: chooseItems.code,
          [field?.bizConfig?.spartCode]: chooseItems.spu,
          ...bindValues,
        });
        // const dataList = cloneDeep(config?.formValue);
        // const rowData = {
        //   ...config?.rowValue,
        //   [field.name]: chooseItems.code,
        //   [field?.bizConfig?.spartCode]: chooseItems.spu,
        //   ...bindValues,
        // };
        // dataList.splice(config.rowIndex, 1, rowData);
        // config.setRowsData(dataList);
        emitEvent && emitEvent({ value: chooseItems.spu, moduleName: moduleInfo.handle, fieldName: field?.bizConfig?.spartCode, rowIndex: config.rowIndex, touchConfig: 'change' });
      } else {
        onChange && onChange(chooseItems.code);
      }
      linkShowModalContrulor(false);
    }
  }, []);

  return {
    showLinkShowModal,
    onSelectChange,
    onModalEnter,
    linkShowModalContrulor,
    setInputLabel,
    clickRow,
    selectedRowKeys,
  };
};
